import { render, staticRenderFns } from "./Form16Layout.vue?vue&type=template&id=7c77667e&scoped=true"
import script from "./Form16Layout.vue?vue&type=script&lang=ts"
export * from "./Form16Layout.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=7c77667e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c77667e",
  null
  
)

export default component.exports